import { useMutation } from "@tanstack/react-query";

import { queryClient } from "../../../config/react-query";
import { useToast } from "../../../hooks/useToast";
import { grappageCancel } from "./actions";

export function useGrappageCancel() {
    const { successToast } = useToast();

    const mutation = useMutation({
        mutationFn: grappageCancel,
        onSuccess: () => successToast("Le dossier a bien été réouvert"),
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: ["folders"],
            });
        },
    });

    return mutation;
}
